import { useMemo } from 'react';
import { useClients } from '~/hooks/reactQuery/queries/useClients';
export const useClientNameOptions = ()=>{
    const { clients } = useClients();
    return useMemo(()=>{
        const seen = new Set();
        const options = [];
        for (const client of clients){
            var _client_name;
            const name = (_client_name = client.name()) === null || _client_name === void 0 ? void 0 : _client_name.trim();
            if (name == null || name.length === 0 || seen.has(name)) continue;
            seen.add(name);
            options.push({
                value: name,
                label: name
            });
        }
        return options.sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        clients
    ]);
};
